<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>护送上户订单-信息菜单使用说明:<br>
					<span>1、提交后数据不能修改,如需修改请先作废,前提是调度员没有使用该订单。</span><br>
					<span>2、一条订单明细对应一个文件</span><br>
					<span>3、父级业务删除单据成功后对应1级业务单据状态修改为其他。</span><br>
					<span>4、查询关键字:单号、护送内容、起点、开始日期。</span><br>
					<span class="red">5、明细中的提交与作废,只有在主单据提交后才能使用,用来针对订货明细单独发起调度单生成和撤回。</span><br>
					<span class="red">6、护送订单:明细不需要选择订单类型</span><br>
				</h5>
			</div>
		</div>

		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<template slot="pre_base_button">
				<button @click="look_hetong">合同追加</button>
			</template>
		</pre-base>
		
		<!-- 文件列表 -->
		<pre-file-type ref="filetype" />

	</div>
</template>

<script>
	export default {
		components: {
			"pre-base": () => import("../auto/auto_view.vue"),
			'pre-file-type': () => import("../base_comp/tan_file_type.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		created() {
			this.fun_init();
		},
		methods: {
			fun_init: function() {

				this.init_data = '';
				this.init_data = JSON.stringify({
					"title": '护送上户订单',
					"control": "order_hs",
					"isTwo": "0",
					"isTwoDetail": "1",
					"action_flag": "",
					"isFileMain": "0",
					"step": "0",
					"sel_action": 'exp_ys_ordernew_m_hs',
					"upd_action": 'exp15_ys_ordernew_m_hs',
					"detail_part": "1",
					"d_btn_more": "1",
					"d_sel_action": 'exp_ys_ordernew_d_hs',
					"d_upd_action": '_ys_ordernew_d_hs',
					"file_action": 'ordernew',
					"p1": 'order',
					"p2": 'hs',
					"p3": '',
					"parm_sel": [
						{
							"name": "业务单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "发货厂家",
							"val": "",
							"key": "f_name",
							"type": "none",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "护送内容",
							"val": "",
							"key": "item_name",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "起点",
							"val": "",
							"key": "s_addr",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "开始日期",
							"val": "",
							"key": "s_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						}
					],
					"parm": [
						{
							"name": "业务单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "经办人",
							"val": "",
							"key": "u_name",
							"type": "select",
							"class": "long1",
							"sel_action": "_base_alluser",
							"sel_name": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "厂家名称",
							"val": "",
							"key": "c_id",
							"type": "none",
							"class": "long1",
							"sel_action": "_base_company",
							"sel_name": "",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						// {
						// 	"name": "厂家电话",
						// 	"val": "",
						// 	"key": "out_phone",
						// 	"type": "text",
						// 	"class": "long1",
						// 	"p": "1",
						// 	"w": "0",
						// 	"r": "0",
						// 	"x": "1"
						// },
						{
							"name": "起点",
							"val": "",
							"key": "item_up_addr",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "终点",
							"val": "",
							"key": "item_down_addr",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "开始日期",
							"val": "",
							"key": "item_up_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "结束日期",
							"val": "",
							"key": "item_down_date",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "护送内容",
							"val": "",
							"key": "item_up_name",
							"type": "text",
							"class": "long3",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						// {
						// 	"name": "费用",
						// 	"val": "",
						// 	"key": "amount",
						// 	"type": "number",
						// 	"class": "long1",
						// 	"p": "0",
						// 	"w": "0",
						// 	"r": "1",
						// 	"x": "1"
						// },
						{
							"name": "规格",
							"val": "",
							"key": "item_up_size",
							"type": "none",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						},
						{
							"name": "重量",
							"val": "",
							"key": "item_up_weight",
							"type": "none",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						},
						{
							"name": "距离",
							"val": "",
							"key": "Distance",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "2"
						},
						{
							"name": "提供人",
							"val": "",
							"key": "out_name",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						},
						{
							"name": "联系方式",
							"val": "",
							"key": "out_phone",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long3",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						}
					],
					"parm_th": [{
							"name": "序号"
						},
						{
							"name": "业务单号"
						},
						{
							"name": "订单类型"
						},
						{
							"name": "经办人"
						},
						// {
						// 	"name": "厂家"
						// },
						// {
						// 	"name": "厂家电话"
						// },
						{
							"name": "起点"
						},
						{
							"name": "终点"
						},
						{
							"name": "开始日期"
						},
						{
							"name": "截至日期"
						},
						{
							"name": "护送信息"
						},
						{
							"name": "货物明细"
						},
						// {
						// 	"name": "规格"
						// },
						// {
						// 	"name": "重量"
						// },
						{
							"name": "距离"
						},
						{
							"name": "提供人"
						},
						{
							"name": "提供人电话"
						},
						{
							"name": "备注",
							"class": "long2"
						},
						{
							"name": "状态",
							"class": "short0"
						},
						{
							"name": "修改人",
							"class": "short0"
						},
						{
							"name": "修改时间",
							"class": "long2"
						}
					],
					"d_parm": [
						{
							"name": "业务单号",
							"val": "",
							"key": "sheet_no",
							"type": "none",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "护送内容",
							"val": "",
							"key": "d_name",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "订单类型",
							"val": "",
							"key": "order_type",
							"type": "none",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "发货运费",
							"val": "0",
							"key": "fh_amount",
							"type": "none",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "配货运费",
							"val": "",
							"key": "ph_amount",
							"type": "none",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "油卡",
							"val": "",
							"key": "card_amount",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "信息费",
							"val": "",
							"key": "xx_amount",
							"type": "none",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "其他支出",
							"val": "",
							"key": "qt_amount",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "起点",
							"val": "",
							"key": "s_addr",
							"type": "text",
							"class": "long1",
							"note":"不填则默认起点",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},						
						{
							"name": "终点",
							"val": "",
							"key": "e_addr",
							"type": "text",
							"class": "long1",
							"note":"不填则默认终点",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "规格",
							"val": "",
							"key": "d_size",
							"type": "none",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "重量",
							"val": "",
							"key": "d_weight",
							"type": "none",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long2",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						}
					],
					"d_name": [{
							"name": "ID"
						},
						{
							"name": "序号"
						},
						{
							"name": "业务单号"
						},
						{
							"name": "业务类型"
						},
						{
							"name": "护送内容"
						},
						{
							"name": "起点"
						},
						{
							"name": "终点"
						},
						// {
						// 	"name": "货物规格"
						// },
						// {
						// 	"name": "货物重量"
						// },
						{
							"name": "运费"
						},
						{
							"name": "油卡"
						},
						{
							"name": "信息费"
						},
						{
							"name": "其他支出"
						},
						{
							"name": "备注",
							"class": "long2"
						},
						{
							"name": "是否生成调度单"
						},
						{
							"name": "附件"
						},
						{
							"name": "修改人",
							"class": "short0"
						},
						{
							"name": "路径1"
						},
						{
							"name": "路径2"
						},
						{
							"name": "更新时间",
							"class": "long2"
						}
					]

				});
			},
			refresh_data: function(type) {
				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data(type);
				});
			},
			refresh_father: function(type, val, parm) {
				console.log('type=' + type + ' val=' + val);
				console.log('type=' + type + ' val=' + val);
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						// this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			},
			look_hetong: function() {
				console.log('row_id='+this.row_id);
				console.log('选择数据',this.item)
				let tsheetno='';
				for(let i=0;i<this.item.length;i++){
					if(this.item[i].key=='sheet_no'){
						tsheetno=this.item[i].val;
					}
				}
				if (this.row_id == 0) {
					this.$message({
						message: '请选择要添加 合同与票据 的调度单!',
						type: 'warning'
					});
					return;
				}
			
				let post_tan = JSON.stringify({
					"title": "合同与票据",
					"sheet_flag": '',
					"sheet_no": tsheetno,
					"sel_action": "exp_filemode_com",
					"file_action": "filemode_com",
				})
				this.$refs.filetype.showpop(post_tan);
			},
			



		}
	};
</script>
<style scoped>


</style>
